<script>
	// Partials
	import SportsMenu from '@/Partials/Sport/Trading/_SportsMenu.svelte';
</script>

<div class="w-1/5 border-r">
	<SportsMenu />
</div>
